const client = {
  dev: {
    FIREBASE_API_KEY: 'AIzaSyBK3rkoDaAHNDjl1j9zoBIwm534FqWCq-A',
    FIREBASE_AUTH_DOMAIN: 'timetracker-dev-a525f.firebaseapp.com',
    FIREBASE_DATABASE_URL: 'https://timetracker-dev-a525f.firebaseio.com',
    FIREBASE_PROJECT_ID: 'timetracker-dev-a525f',
    FIREBASE_STORAGE_BUCKET: 'timetracker-dev-a525f.appspot.com',
    FIREBASE_MESSAGING_SENDER_ID: '66189812406',
    GA_TRACKING_ID: 'UA-118872851-4',
    GA_DEBUG: true,
  },
  prod: {
    FIREBASE_API_KEY: 'AIzaSyB-Df1Eey5-fK1nsh15qE135rchBEIQpt8',
    FIREBASE_AUTH_DOMAIN: 'timetracker-48cd0.firebaseapp.com',
    FIREBASE_DATABASE_URL: 'https://timetracker-48cd0.firebaseio.com',
    FIREBASE_PROJECT_ID: 'timetracker-48cd0',
    FIREBASE_STORAGE_BUCKET: 'timetracker-48cd0.appspot.com',
    FIREBASE_MESSAGING_SENDER_ID: '678732751111',
    GA_TRACKING_ID: 'UA-118872851-3',
    GA_DEBUG: false,
  },
};

const manager = {
  dev: {
    FIREBASE_API_KEY: 'AIzaSyBTbP-0OsF8g8UOW4cjChAKV6whnVGHn6U',
    FIREBASE_AUTH_DOMAIN: 'timetracker-manager-dev.firebaseapp.com',
    FIREBASE_DATABASE_URL: 'https://timetracker-manager-dev.firebaseio.com',
    FIREBASE_PROJECT_ID: 'timetracker-manager-dev',
    FIREBASE_STORAGE_BUCKET: 'timetracker-manager-dev.appspot.com',
    FIREBASE_MESSAGING_SENDER_ID: '67143581231',
  },
  prod: {
    FIREBASE_API_KEY: 'AIzaSyD5ma954rxy7hZtsVSaUUZdGMvjJa4BryM',
    FIREBASE_AUTH_DOMAIN: 'timetracker-manager.firebaseapp.com',
    FIREBASE_DATABASE_URL: 'https://timetracker-manager.firebaseio.com',
    FIREBASE_PROJECT_ID: 'timetracker-manager',
    FIREBASE_STORAGE_BUCKET: 'timetracker-manager.appspot.com',
    FIREBASE_MESSAGING_SENDER_ID: '1057791531163',
  },
};

export const clientConfig = client[process.env.REACT_APP_ENV] || {};
export const managerConfig = manager[process.env.REACT_APP_ENV] || {};



// WEBPACK FOOTER //
// ./src/config.js